// API client for the 6 Inventory Health Monitor endpoints + settings.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/inventory-health`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

const call = async (url, options = {}) => {
  const res = await fetch(url, options);
  const body = await res.json();
  if (!res.ok || body.error) {
    throw new Error(body.error || body.message || `Request failed (${res.status})`);
  }
  return body;
};

// Each endpoint returns { data, freshness }.
export const getCurrentLevels = (token) =>
  call(`${BASE}/current-levels`, { headers: authHeaders(token) });

export const getStockOutRisk = (token) =>
  call(`${BASE}/stock-out-risk`, { headers: authHeaders(token) });

export const getDaysOnHand = (token) =>
  call(`${BASE}/days-on-hand`, { headers: authHeaders(token) });

export const getTurnoverCorridor = (token) =>
  call(`${BASE}/turnover-corridor`, { headers: authHeaders(token) });

export const getDeadStockReport = (token) =>
  call(`${BASE}/dead-stock-report`, { headers: authHeaders(token) });

export const getValueReport = (token) =>
  call(`${BASE}/value-report`, { headers: authHeaders(token) });

export const getOverview = (token, { refresh = false } = {}) =>
  call(`${BASE}/overview${refresh ? '?refresh=1' : ''}`, { headers: authHeaders(token) });

export const getAsinDetail = (token, asin) =>
  call(`${BASE}/asin/${encodeURIComponent(asin)}`, { headers: authHeaders(token) });

export const getSettings = (token) =>
  call(`${BASE}/settings`, { headers: authHeaders(token) });

export const updateSettings = (token, values) =>
  call(`${BASE}/settings`, {
    method: 'POST',
    headers: authHeaders(token),
    body: JSON.stringify(values),
  });
